import { env } from '@repo/env';

export const getPlatformUrl = () => {
  return env.VITE_PLATFORM_URL?.endsWith('/') ? env.VITE_PLATFORM_URL : `${env.VITE_PLATFORM_URL}/`;
};
